import { envConfig } from "../../utils/constants";
import { PackageState } from "../../utils/interfaces/packages";
import { client } from "../graphql";
import { GET_PACKAGES } from "./queries";

class PackageServices {
  async fetchPackages(catUID: String): Promise<PackageState> {
    const res = await client.query({
      query: GET_PACKAGES,
      variables: { catUID },
      context: { headers: { store: envConfig.store } },
      fetchPolicy: "no-cache",
    });
    return res.data.products;
  }

  setPackages = async (
    id: string,
    action: (res: any) => void,
    callback: () => void
  ) => {
    await this.fetchPackages(id)
      .then((res: any) => {
        // need to check
        if (res) {
          action(res);
        }
        callback();
      })
      .catch((e: Error) => {
        callback();
      });
  };
}

export default new PackageServices();
